var map = {
	"./ACGIH-Heavy": 401,
	"./ACGIH-Heavy.json": 401,
	"./ACGIH-Light": 402,
	"./ACGIH-Light.json": 402,
	"./ACGIH-Moderate": 403,
	"./ACGIH-Moderate.json": 403,
	"./ACSM-Acclimatized": 404,
	"./ACSM-Acclimatized.json": 404,
	"./ACSM-NonAcclimatized": 405,
	"./ACSM-NonAcclimatized.json": 405,
	"./GaStateHighSchool": 406,
	"./GaStateHighSchool.json": 406,
	"./KyStateHighSchool": 407,
	"./KyStateHighSchool.json": 407,
	"./NATA": 408,
	"./NATA.json": 408,
	"./NcStateHighSchool": 409,
	"./NcStateHighSchool.json": 409,
	"./NjStateHighSchool": 410,
	"./NjStateHighSchool.json": 410,
	"./TBMed507-Easy": 411,
	"./TBMed507-Easy.json": 411,
	"./TBMed507-Hard": 412,
	"./TBMed507-Hard.json": 412,
	"./TBMed507-Moderate": 413,
	"./TBMed507-Moderate.json": 413,
	"./UsaSoccer-Cat1": 414,
	"./UsaSoccer-Cat1.json": 414,
	"./UsaSoccer-Cat2": 415,
	"./UsaSoccer-Cat2.json": 415,
	"./UsaSoccer-Cat3": 416,
	"./UsaSoccer-Cat3.json": 416,
	"./VtStateHighSchool": 417,
	"./VtStateHighSchool.json": 417,
	"./_HeatStressGuidelinesIndex": 322,
	"./_HeatStressGuidelinesIndex.json": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;